export default __webpack_public_path__ + "static/image-pod-landing-page-3f5b915445226be4e0ddfcc4bc808e45.png";